import httpClient from "../apiClient";
import * as Type from "./index.types";

export const FUNDED_COMPLIANCE_API_URLS = {
  tradersDbList: "funded-compliance/db-accounts",
  tradersSearch: "funded-compliance/db-accounts/search",
  traderProfile: "funded-compliance/db-account",
  notes: "funded-compliance/db-account/notes",
  submissionToPropList: "funded-compliance/submission-to-prop",
  withdrawals: "funded-compliance/withdrawals-requested",
} as const;

export class FundedComplianceAPI {
  static getTradersDbListRequest: Type.TGetTradersDbListRequest = (query, signal) =>
    httpClient.get(`${FUNDED_COMPLIANCE_API_URLS.tradersDbList}?${query}`, { signal });
  static changeGroupMemberRequest: Type.TChangeGroupMemberRequest = (id, body) =>
    httpClient.put(`${FUNDED_COMPLIANCE_API_URLS.tradersDbList}/${id}`, body);
  static deleteFromGroupRequest = (id: number): Promise<void> =>
    httpClient.delete(`${FUNDED_COMPLIANCE_API_URLS.tradersDbList}/${id}`);
  static addInOrCreateGroupRequest: Type.TAddInGroupOrCreateGroupRequest = (body) =>
    httpClient.post(`${FUNDED_COMPLIANCE_API_URLS.tradersDbList}`, body);
  static getTradersSearchRequest: Type.TGetTradersSearchRequest = (query, signal) =>
    httpClient.get(`${FUNDED_COMPLIANCE_API_URLS.tradersSearch}?${query}`, { signal });

  static getTraderProfileRequest: Type.TGetTraderProfileRequest = (id, signal) =>
    httpClient.get(`${FUNDED_COMPLIANCE_API_URLS.traderProfile}/${id}`, { signal });

  static getSubmissionToPropListRequest: Type.TGetSubmissionToPropListRequest = (query, signal) =>
    httpClient.get(`${FUNDED_COMPLIANCE_API_URLS.submissionToPropList}?${query}`, { signal });
  static updateSubmissionToPropRecordRequest: Type.TUpdateSubmissionToPropRequest = (body) =>
    httpClient.put(`${FUNDED_COMPLIANCE_API_URLS.submissionToPropList}`, body);

  static getWithdrawalsRequest: Type.TGetWithdrawalsRequestRequest = (query, signal) =>
    httpClient.get(`${FUNDED_COMPLIANCE_API_URLS.withdrawals}?${query}`, { signal });
  static updateWithdrawalsRequest: Type.TUpdateWithdrawalsRequestRequest = (body) =>
    httpClient.put(`${FUNDED_COMPLIANCE_API_URLS.withdrawals}`, body);

  static createNoteRequest: Type.TCreateNoteRequest = (body, id) =>
    httpClient.post(`${FUNDED_COMPLIANCE_API_URLS.notes}/${id}`, body);
  static getNotesRequest: Type.TGetNotesRequest = (id, query, signal) =>
    httpClient.get(`${FUNDED_COMPLIANCE_API_URLS.notes}/${id}?${query}`, { signal });
  static updateNoteRequest: Type.TUpdateNoteRequest = (body) =>
    httpClient.put(`${FUNDED_COMPLIANCE_API_URLS.notes}/${body.id}`, body);
  static deleteNoteRequest: Type.TDeleteNoteRequest = (id) =>
    httpClient.delete(`${FUNDED_COMPLIANCE_API_URLS.notes}/${id}`);
}
